import React, { useEffect, useRef, useState } from 'react';
import {
	MobileUploadContainer,
	UploadImageMobileModal,
} from './uploadimagemobile.styled';
import Button from '../../../../FlyfishComponents/Button';
import Input from '../../../../FlyfishComponents/Input';
import {
	loadStateSession,
	saveStateSession,
} from '../../../../FlyfishComponents/flyfishutils/utils';
import Axios from 'axios';
import CameraAccess from '../CameraAccess';
import TimeUtil from '../../../../../Utils/TimeUtil';
import Modal from '../../../../FlyfishComponents/Modal';
import { PlaceholderSVG } from './svg';
import useScreenType from '../../../../../Components/Hooks/DeviceType';

export default function UploadImageMobile({
	setEnableUpload,
	setTime,
	setTopProductID,
	setMetaData,
	setCategoriesProductsArray,
	setChatMessages,
	setShowChat,
	setLoader,
	msgId,
	responseId,
	token,
	setPreviewImage,
	previewImage,
	setQueryText,
	setShowImageInInput,
	setFilters,
	setOptions,
	setPagination,
	setProductCount,
	setPaginatedCount,
	clearFilter
}) {
	const [imageURL, setImageURL] = useState('');
	const [error, setError] = useState('');
	const [urlValidation, setUrlValidation] = useState('');
	const uploadRef = useRef(null);
	const fileReImportRef = useRef(null);
	const [openCamera, setOpenCamera] = useState(false);
	const [imageUploadLoader, setImageUploadLoader] = useState(false);
	const deviceType = useScreenType();
	const handleAPI = (bas64?) => {
		setImageUploadLoader(true);
		let payload = {
			messageId: msgId ?? 0,
			id: responseId ?? 0,
			botId: loadStateSession('botId') ?? loadStateSession('botID'),
			version: 'prod',
			image_link: imageURL.trim(),
			image_base64: bas64 ? bas64.split(',')[1] : '',
		};
		// setLoader(true);
		let message = [];
		let chatMessageDataUser = {
			message: '',
			timeStamp: TimeUtil.getCurrentTime(new Date()),
			key: null,
			messageType: 'user',
			customInfos: {},
			suggestionChips: [],
		};
		clearFilter()
		Axios.post(
			`${window['BASE_URL']}/conversation/image`,
			JSON.stringify(payload),
			{
				headers: {
					'Content-Type': 'application/json',
					'x-tenant-id':
						loadStateSession('tenantID') ?? loadStateSession('tenantId'),
					Authorization: `Bearer ${token}`,
				},
			}
		)
			.then((resp) => {
				if (resp.status >= 500 && resp.status < 600) {
					throw new Error('failed to fetch');
				}
				// setLoader(false);
				setImageUploadLoader(false);
				setPagination(2);
				setPaginatedCount(1);
				saveStateSession('filters', {})
				let response = resp.data;
				setProductCount(response.metaData.total_product_count);
				let chatMessageDataServer = {
					message: response,
					timeStamp: TimeUtil.getCurrentTime(new Date()),
					key: null,
					messageType: 'server',
					customInfos: {},
					suggestionChips: [],
					conversationalId: response.id,
					thumbFilledUp: null,
					messageId: response.messageId,
				};
				setTime(chatMessageDataServer.timeStamp);
				if (
					response.metaData.products &&
					response.metaData.products.length > 0
					// ||					!queryFromPD
				) {
					const topProductIds = new Set(
						response.metaData.products
							.filter(
								(product) => product.category.toLowerCase() === 'top products'
							)
							.map((product) => product.product_id)
					);
					setTopProductID(topProductIds);
					setMetaData(response.metaData);
					setCategoriesProductsArray([
						{
							category:
								response.metaData &&
								response.metaData.categories &&
								response.metaData.categories[0],
							products: response.metaData && response.metaData.products,
							rows: 2,
						},
					]);
				}

				message.push({ chatMessageDataUser, chatMessageDataServer });
				setChatMessages((prev) => [...prev, message]);
				setShowChat(true);
				setFilters(response.metaData.filters);
				setOptions(
					response.metaData.filters[0][
					response.metaData.filters[0].filter_caption
					]
				);
				// clearTimeout(directTimeout.current);
				// setLoader(false);
				setEnableUpload(false);
				setQueryText('Your image: ');
				setShowImageInInput(true);
			})
			.catch((error) => {
				// setLoader(false);
				setImageUploadLoader(false);
				// setEnableUpload(true);

				let offlineMessage = 'Something went wrong please try after sometime';

				if (error.message) {
					offlineMessage = error.message;
					if (error.message.toLowerCase() === 'failed to fetch') {
						offlineMessage = `Couldn't connect to the server. Please retry. If the issue persists, check your connection and try again later.`;
					}
				}

				if (!navigator.onLine) {
					setError(`Seems like you are not connected to a network.`);
				} else {
					setError(offlineMessage);
				}
			});
	};
	const validateURL = (url) => {
		const imageUrlRegex =
			/^https:\/\/[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+(:\d+)?(\/[a-zA-Z0-9-_]+)*\/[a-zA-Z0-9-_]+\.(jpg|jpeg|png|gif|bmp|webp)(_[a-zA-Z0-9]+)?(\?.*)?$/;
		if (!imageUrlRegex.test(url)) {
			setUrlValidation('Please enter a valid URL');
			return;
		} else {
			setUrlValidation('');
			setPreviewImage(url);
			saveStateSession('imgUrl', url);
			handleAPI();
		}
	};

	const handleImageUpload = (e) => {
		e.preventDefault();
		const maxSize = 5 * 1024 * 1024; // 5 MB
		const acceptedFormats = [
			'image/jpeg',
			'image/png',
			'image/tiff',
			'image/webp',
			'image/bmp',
		];
		const files = e.target.files || e.dataTransfer.files;

		if (files && files[0]) {
			const file = files[0];

			if (!acceptedFormats.includes(file.type)) {
				setError(
					`Please ensure that your image is in .jpg, .png, .tif, .webp or .bmp format.`
				);
				return;
			}
			if (file.size > maxSize) {
				setError(`Please ensure that your image is less than 5MB in size.`);
				return;
			}

			setError('');
			const reader = new FileReader();
			reader.onload = (e) => {
				if (typeof e.target.result === 'string') {
					// handleAPI(e.target.result);
					setPreviewImage(e.target.result);
					saveStateSession('imgUrl', e.target.result);
				} else {
					setError('Failed to read the image file.');
				}
			};
			reader.readAsDataURL(file);
		}
	};
	useEffect(() => {
		function handleClickOutside(event) {
			if (uploadRef.current && !uploadRef.current.contains(event.target)) {
				setEnableUpload(false);
			}
		}

		document.addEventListener('pointerdown', handleClickOutside);
		return () => {
			document.removeEventListener('pointerdown', handleClickOutside);
		};
	}, [uploadRef]);
	useEffect(() => {
		if (imageURL.length > 0) {
			validateURL(imageURL);
		}
	}, [imageURL]);
	return (
		<UploadImageMobileModal
			className={`${imageUploadLoader ? 'loader' : ''} ${error && error.length > 0 ? 'error' : ''
				}`}
		>
			<Modal
				headerCloseBtn={false}
				footerNotReq={true}
				onClose={() => {
					if (imageUploadLoader) {
					} else {
						setEnableUpload(false);
					}
				}}
				remove
			>
				{imageUploadLoader ? (
					<div className='uploading-loader'>
						<svg
							xmlns='http://www.w3.org/2000/svg'
							width='25'
							height='24'
							viewBox='0 0 25 24'
							fill='none'
						>
							<path
								d='M20.25 12C20.25 16.2802 16.7802 19.75 12.5 19.75C8.21979 19.75 4.75 16.2802 4.75 12C4.75 7.71979 8.21979 4.25 12.5 4.25V2C6.97715 2 2.5 6.47715 2.5 12C2.5 17.5228 6.97715 22 12.5 22C18.0228 22 22.5 17.5228 22.5 12H20.25Z'
								fill='var(--primary-color-ff-primary500)'
							/>
						</svg>
						<div className='ff-chatbot-body1'>Uploading Image</div>
					</div>
				) : error && error.length > 0 ? (
					<div className='error-message'>
						<svg
							xmlns='http://www.w3.org/2000/svg'
							width='48'
							height='48'
							viewBox='0 0 48 48'
							fill='none'
						>
							<g id='error'>
								<path
									id='Vector'
									d='M24 4C12.96 4 4 12.96 4 24C4 35.04 12.96 44 24 44C35.04 44 44 35.04 44 24C44 12.96 35.04 4 24 4ZM26 34H22V30H26V34ZM26 26H22V14H26V26Z'
									fill='#FB5C53'
								/>
							</g>
						</svg>
						<div className='msg1 ff-chatbot-h6'>Couldn't upload the image</div>
						<div className='msg2 ff-chatbot-body1'>{error}</div>
						<Button
							onClick={() => {
								if (fileReImportRef.current) {
									//@ts-ignore
									fileReImportRef.current.click();
								}
							}}
						>
							Try again
						</Button>
					</div>
				) : (
					<MobileUploadContainer
						className={`ff-upload-image-mobile-ecom-search ${deviceType}`}
						ref={uploadRef}
					>
						{!previewImage ? (
							<div>
								<h6 className='title-search-mobile'>Search with image</h6>
								<div className='svg-holder'>
									<PlaceholderSVG />
								</div>

								<div className='ff-chatbot-body1'>
									Upload a pic of any product and we will find similar products
									for you
								</div>
								<label htmlFor='captureWithCamera'>
									<Button
										onClick={() => {
											setOpenCamera(true);
											let camera = document.getElementById('uploadFromCamera');
											if (camera) {
												camera.click();
											}
										}}
										component='span'
										startIcon={
											<svg
												xmlns='http://www.w3.org/2000/svg'
												width='25'
												height='24'
												viewBox='0 0 25 24'
												fill='none'
											>
												<g id='center_focus_weak'>
													<path
														id='Vector'
														d='M5.5 15H3.5V19C3.5 20.1 4.4 21 5.5 21H9.5V19H5.5V15ZM5.5 5H9.5V3H5.5C4.4 3 3.5 3.9 3.5 5V9H5.5V5ZM12.5 8C10.29 8 8.5 9.79 8.5 12C8.5 14.21 10.29 16 12.5 16C14.71 16 16.5 14.21 16.5 12C16.5 9.79 14.71 8 12.5 8ZM12.5 14C11.4 14 10.5 13.1 10.5 12C10.5 10.9 11.4 10 12.5 10C13.6 10 14.5 10.9 14.5 12C14.5 13.1 13.6 14 12.5 14ZM19.5 3H15.5V5H19.5V9H21.5V5C21.5 3.9 20.6 3 19.5 3ZM19.5 19H15.5V21H19.5C20.6 21 21.5 20.1 21.5 19V15H19.5V19Z'
														fill='white'
													/>
												</g>
											</svg>
										}
									>
										Capture with camera
									</Button>
									{openCamera && (
										<CameraAccess
											setOpenCamera={setOpenCamera}
											handleImageUpload={handleImageUpload}
										/>
									)}
								</label>
								<label htmlFor='uploadImageFromMobile'>
									<Button
										component='span'
										startIcon={
											<svg
												xmlns='http://www.w3.org/2000/svg'
												width='25'
												height='24'
												viewBox='0 0 25 24'
												fill='none'
											>
												<g id='collections'>
													<path
														id='Vector'
														d='M20.5 4V16H8.5V4H20.5ZM20.5 2H8.5C7.4 2 6.5 2.9 6.5 4V16C6.5 17.1 7.4 18 8.5 18H20.5C21.6 18 22.5 17.1 22.5 16V4C22.5 2.9 21.6 2 20.5 2ZM12 11.67L13.69 13.93L16.17 10.83L19.5 15H9.5L12 11.67ZM2.5 6V20C2.5 21.1 3.4 22 4.5 22H18.5V20H4.5V6H2.5Z'
														fill='white'
													/>
												</g>
											</svg>
										}
									>
										Upload from gallery
									</Button>
								</label>
								<div className='separator'>
									<div className='separator-line'></div>
									<div className='separator-text'>OR</div>
									<div className='separator-line'></div>
								</div>

								<Input
									value={imageURL}
									onChange={(e) => setImageURL(e.target.value)}
									placeholder='Paste an image link'
									error={urlValidation.length > 0}
									errorText={urlValidation}
								/>
							</div>
						) : (
							<div className='ff-image-preview'>
								<img src={previewImage} alt='' />
								<div className='image-buttons'>
									<Button
										buttonType='light'
										onClick={() =>
											fileReImportRef && fileReImportRef.current.click()
										}
									>
										Choose another
									</Button>
									<Button onClick={() => handleAPI(previewImage)}>
										Continue
									</Button>
								</div>
							</div>
						)}

						{/* {error && <div className='error-image'>{error}</div>} */}
					</MobileUploadContainer>
				)}
			</Modal>
			<input
				ref={fileReImportRef}
				id='uploadImageFromMobile'
				type='file'
				accept='.jpg,.jpeg,.png,.tiff,.webp,.bmp'
				style={{ display: 'none' }}
				onChange={handleImageUpload}
			/>
		</UploadImageMobileModal>
	);
}
